import React from "react";
import {
  Box,
  Button,
  Text,
  VStack,
  useToast,
  Flex,
  useBreakpointValue,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../config/axiosInstance";

const SharedLogout = () => {
  const toast = useToast();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await axiosInstance.post("/api/auth/logout");

      // Clear localStorage
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      localStorage.removeItem("email");

      toast({
        title: "Logged out successfully",
        status: "success",
        isClosable: true,
        duration: 3000,
      });

      navigate("/login");
    } catch (error) {
      toast({
        title: "Logout failed",
        description: error?.response?.data?.message || "Server error",
        status: "error",
        isClosable: true,
      });
    }
  };

  // Responsive width
  const boxWidth = useBreakpointValue({ base: "90%", sm: "400px", md: "500px" });

  return (
    <Flex minH="100vh" align="center" justify="center" bg="gray.50" px={4}>
      <Box
        w={boxWidth}
        bg="white"
        p={{ base: 6, md: 8 }}
        rounded="lg"
        shadow="lg"
        textAlign="center"
      >
        <VStack spacing={6}>
          <Text fontSize={{ base: "xl", md: "2xl" }} fontWeight="bold">
            Are you sure you want to log out?
          </Text>
          <Flex gap={4} direction={{ base: "column", sm: "row" }} w="full" justify="center">
            <Button colorScheme="red" onClick={handleLogout} w={{ base: "full", sm: "auto" }}>
              Yes, Logout
            </Button>
            <Button
              variant="outline"
              onClick={() => navigate(-1)}
              w={{ base: "full", sm: "auto" }}
            >
              No, Go Back
            </Button>
          </Flex>
        </VStack>
      </Box>
    </Flex>
  );
};

export default SharedLogout;
